export default __webpack_public_path__ + "static/media/target.1ae6cb31.svg";